import { useEffect, useRef } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import styles from './styles';

const PcPerformanceTips = ({
  name,
  pcConfigDoc,
  isTooltipOpen,
  handleCloseModal,
}) => {
  const title = pcConfigDoc?.data?.[`${name}_title`];
  const description = pcConfigDoc?.data?.[`${name}_description`];

  if (!title || !description) return null;

  const useOutsideClick = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          handleCloseModal();
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  return (
    <>
      {description && isTooltipOpen === true ? (
        <>
          <div className="performance-description" ref={wrapperRef}>
            <h5>{title}</h5>

            <div className="contents">{RichText.render(description)}</div>

            <div className="close" onClick={handleCloseModal}>
              <Image draggable={false}
                src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-close_5.png?v=1714062936"
                alt="performance tip"
                width={15}
                height={15}
              />
            </div>
          </div>
          <div className="arrow-top" />
        </>
      ) : null}
      <style global jsx>
        {`
          .contents a {
            color: #fd0300;
          }
        `}
      </style>

      <style jsx>{styles}</style>
    </>
  );
};

PcPerformanceTips.propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pcConfigDoc: PropTypes.object.isRequired,
  isTooltipOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

export default PcPerformanceTips;
